var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',{attrs:{"type":"card"}},[_c('template',{slot:"header"},[_vm._v("Header")]),_c('d2-demo-article'),_c('template',{slot:"footer"},[_vm._v("Footer")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }